<div class="attached-files-container">
    <div class="attached-files-header" [ngClass]="headerClasses">{{header}}</div>
  <div class="table">
    <app-generic-table *ngIf="tableData?.length"
      [ngStyle]="{'--table-height': tableHeight + 'px'}"
      [data]="tableData" 
      [columns]="columns"
      [withDetailsOption]="true"
      detailsControlName="Edit"
      (sorted)="saveSorted($event)"
      (goToDetail)="openAttachFilesDialog($event, true)"
      (onRowClick)="downloadFileClicked($event)"
    ></app-generic-table>
  </div>
   
    <app-button (clicked)="openAttachFilesDialog($event, false)"
      styleClass="settings mt-2"
      subStyle="blue"
      customClasses="attach-btn"
    >
    <img class="plus-icon" src="assets/icons/icon-plus-blue.svg" alt="add-order-attachment" />
      Add new file
    </app-button>
  </div>


<app-receive-attachments-dialog *ngIf="showAttachFilesDialog && defaultReceiveAttachmentDialog"
                                [requiresSignature]="requiresSignature"
                                [show]="true"
                                [csosControl]="csosControl"
                                [editMode]="isEditMode"
                                [uploadedFiles]="isEditMode ? [editableFile] : []"
                                [fileTypes]="fileTypes"
                                (closeDialog)="saveAttachmentsList($event)"
                                (cancel)="closeAttachFilesDialog()"
></app-receive-attachments-dialog>